(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jesoli-shipping-policy"]) return;
  try {
    
  class JesoliPolicyContent extends HTMLElement {
    connectedCallback() {
      if (this.dataset.accordionReady === 'true') return;

      this.dataset.accordionReady = 'true';
      if (this.dataset.prebuilt === 'true') {
        const accordions = Array.from(this.children).filter((element) => element.tagName === 'DETAILS');

        for (const details of accordions) {
          const summary = details.querySelector(':scope > summary');
          const content = details.querySelector(':scope > .jesoli-policy__accordion-content');
          if (summary && content) this.bindAccordion(summary, details, content);
        }

        return;
      }

      const summaryTargetId = this.dataset.summaryTarget;
      if (summaryTargetId) {
        const summaryTarget = document.getElementById(summaryTargetId);
        const summaryHeading = Array.from(this.children).find(
          (element) =>
            element.tagName === 'H2' && element.textContent.trim().toLowerCase() === 'returns at a glance'
        );
        const summaryList = summaryHeading?.nextElementSibling;

        if (summaryTarget && summaryHeading && summaryList?.tagName === 'UL') {
          const summaryHeadingId = `${summaryTargetId}-heading`;
          summaryHeading.id = summaryHeadingId;
          summaryTarget.setAttribute('aria-labelledby', summaryHeadingId);
          summaryTarget.append(summaryHeading, summaryList);
        } else {
          summaryTarget?.remove();
        }
      }

      const headings = Array.from(this.children).filter((element) => element.tagName === 'H2');

      for (const heading of headings) {
        if (heading.textContent.trim().toLowerCase() === 'contact') continue;

        const sectionNodes = [];
        let sibling = heading.nextSibling;

        while (sibling && !(sibling.nodeType === Node.ELEMENT_NODE && sibling.tagName === 'H2')) {
          const nextSibling = sibling.nextSibling;
          sectionNodes.push(sibling);
          sibling = nextSibling;
        }

        const details = document.createElement('details');
        const summary = document.createElement('summary');
        const content = document.createElement('div');
        const contentInner = document.createElement('div');
        const icon = document.createElement('span');

        details.className = 'jesoli-policy__accordion';
        summary.className = 'jesoli-policy__accordion-summary';
        content.className = 'jesoli-policy__accordion-content';
        contentInner.className = 'jesoli-policy__accordion-inner';
        icon.className = 'jesoli-policy__accordion-icon';
        icon.setAttribute('aria-hidden', 'true');
        heading.classList.add('jesoli-policy__accordion-title');

        heading.before(details);
        summary.append(heading, icon);
        details.append(summary, content);
        content.append(contentInner);

        for (const node of sectionNodes) contentInner.append(node);

        this.bindAccordion(summary, details, content);
      }
    }

    bindAccordion(summary, details, content) {
      summary.addEventListener('click', (event) => {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        event.preventDefault();
        this.animateAccordion(details, content);
      });
    }

    animateAccordion(details, content) {
      const isClosing = details.dataset.accordionClosing === 'true';
      const shouldOpen = !details.open || isClosing;
      const startHeight = details.open ? content.getBoundingClientRect().height : 0;
      const startOpacity = details.open ? Number.parseFloat(getComputedStyle(content).opacity) : 0;

      details.jesoliCancelAnimation?.();
      details.classList.add('is-animating');
      content.style.height = `${startHeight}px`;
      content.style.opacity = startOpacity;

      if (shouldOpen) {
        details.open = true;
        delete details.dataset.accordionClosing;
      } else {
        details.dataset.accordionClosing = 'true';
      }

      content.getBoundingClientRect();
      content.style.height = `${shouldOpen ? content.scrollHeight : 0}px`;
      content.style.opacity = shouldOpen ? 1 : 0;

      let isComplete = false;
      let fallbackTimer;

      const completeAnimation = () => {
        if (isComplete) return;

        isComplete = true;
        content.removeEventListener('transitionend', handleTransitionEnd);
        window.clearTimeout(fallbackTimer);
        if (!shouldOpen) details.open = false;
        delete details.dataset.accordionClosing;
        delete details.jesoliCancelAnimation;
        details.classList.remove('is-animating');
        content.style.removeProperty('height');
        content.style.removeProperty('opacity');
      };

      const handleTransitionEnd = (event) => {
        if (event.target !== content || event.propertyName !== 'height') return;

        completeAnimation();
      };

      details.jesoliCancelAnimation = () => {
        content.removeEventListener('transitionend', handleTransitionEnd);
        window.clearTimeout(fallbackTimer);
        delete details.jesoliCancelAnimation;
      };

      content.addEventListener('transitionend', handleTransitionEnd);
      fallbackTimer = window.setTimeout(completeAnimation, 320);
    }
  }

  if (!customElements.get('jesoli-policy-content')) {
    customElements.define('jesoli-policy-content', JesoliPolicyContent);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const openCategoryFilters = document.querySelectorAll('.jesoli-category-filter[open]');
    for (const filter of openCategoryFilters) {
      if (!filter.contains(event.target)) filter.removeAttribute('open');
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    const openCategoryFilter = document.querySelector('.jesoli-category-filter[open]');
    if (!(openCategoryFilter instanceof HTMLDetailsElement)) return;

    openCategoryFilter.open = false;
    openCategoryFilter.querySelector('summary')?.focus();
  });

  } catch(e) { console.error(e); }
})();
})();
